import React from 'react';
import { FaLeaf, FaCalendarAlt, FaRuler, FaInfoCircle, FaExclamationTriangle } from 'react-icons/fa';

const FieldPopup = ({ feature }) => {
  const { properties } = feature;
  
  // Determine health status color and icon
  const getHealthStatus = (health) => {
    if (health >= 70) {
      return { 
        color: '#4caf50', // Green
        icon: <FaLeaf style={{ color: '#4caf50' }} />,
        text: 'Good'
      };
    } else if (health >= 40) {
      return { 
        color: '#ffc107', // Yellow
        icon: <FaInfoCircle style={{ color: '#ffc107' }} />,
        text: 'Moderate'
      };
    } else {
      return { 
        color: '#f44336', // Red
        icon: <FaExclamationTriangle style={{ color: '#f44336' }} />,
        text: 'Poor'
      };
    }
  };
  
  const healthStatus = properties.health ? getHealthStatus(properties.health) : null;
  
  return (
    <div className="field-popup">
      <h3>{properties.name}</h3>
      
      {properties.crop && (
        <div className="field-detail">
          <FaLeaf style={{ color: '#4caf50' }} />
          <span>Crop: <strong>{properties.crop}</strong></span>
        </div>
      )}
      
      {properties.area && (
        <div className="field-detail">
          <FaRuler style={{ color: '#555' }} />
          <span>Area: <strong>{properties.area} acres</strong></span>
        </div>
      )}
      
      {properties.plantDate && (
        <div className="field-detail">
          <FaCalendarAlt style={{ color: '#555' }} />
          <span>Planted: <strong>{new Date(properties.plantDate).toLocaleDateString()}</strong></span>
        </div>
      )}
      
      {properties.health && (
        <div className="field-health">
          <div className="health-header">
            {healthStatus.icon}
            <span>Health Index: <strong>{healthStatus.text}</strong></span>
          </div>
          <div className="health-bar-container">
            <div 
              className="health-bar" 
              style={{ 
                width: `${properties.health}%`,
                backgroundColor: healthStatus.color
              }}
            ></div>
          </div>
          <div className="health-value">{properties.health}</div>
        </div>
      )}
      
      {properties.type === 'water' && (
        <div className="field-detail">
          <span>Water Source: <strong>{properties.capacity}</strong></span>
        </div>
      )}
      
      {properties.notes && (
        <div className="field-notes">
          <FaInfoCircle style={{ color: '#555' }} />
          <p>{properties.notes}</p>
        </div>
      )}
    </div>
  );
};

export default FieldPopup; 